import { Bell, BellRing } from 'lucide-react'
import { useAdminPush } from '@/contexts/AdminPushContext'
import { Button } from '@/components/ui/Button'
import { isNotificationSupported } from '@/lib/messaging'

export function AdminPushPrompt() {
  const { enabled, loading, enablePush, isConfigured } = useAdminPush()

  if (!isConfigured || !isNotificationSupported() || enabled) return null

  if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
    return (
      <div className="mb-4 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-200/90">
        Notifications are blocked in your browser. Allow them in site settings to
        get instant order alerts.
      </div>
    )
  }

  return (
    <div className="mb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-xl border border-gold-500/25 bg-gold-500/5 px-4 py-3">
      <div className="flex items-start gap-3">
        <Bell className="h-5 w-5 text-gold-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-zinc-200">
            Get instant alerts for new orders
          </p>
          <p className="text-xs text-zinc-500 mt-0.5">
            Enable push notifications on this device (works when the admin panel
            is open or in the background).
          </p>
        </div>
      </div>
      <Button
        size="sm"
        loading={loading}
        onClick={() => void enablePush()}
        className="shrink-0"
      >
        <BellRing className="h-4 w-4" /> Enable alerts
      </Button>
    </div>
  )
}
